import { Cookie } from '@nuxt-common/util/app/utils/cookie';
import signInTooltipTags from '#shared/features/analytics/signInTooltipTags';

export default function useSignInClick(params = {}) {
  const { redirectUrl = window.location.href, tooltipTags = false } = params;

  Cookie.set('SignedIn', '0');
  Cookie.set('FORWARDPAGE_KEY', redirectUrl);

  if (tooltipTags) {
    signInTooltipTags();
  }
}
